import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import RequiredLabel from "../../shared/RequiredLabel";

const FormTextField = ({
  label,
  name,
  value,
  onChange,
  placeholder = "",
  isRequired = false,
  maxLength,
  helperText,
  error = false,
  disabled = false,
}) => {
  const charCount = value ? value.length : 0;

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography sx={{ fontSize: 14 }}>{label}</Typography>
        <RequiredLabel show={isRequired} />
      </Box>
      <TextField
        fullWidth
        name={name}
        value={value}
        onChange={onChange}
        error={error}
        placeholder={placeholder}
        inputProps={maxLength ? { maxLength } : {}}
        helperText={helperText || (maxLength ? `${charCount}文字` : undefined)}
        FormHelperTextProps={{
          sx: { textAlign: "right", marginRight: "0" },
        }}
        multiline={false}
        disabled={disabled}
        sx={{
          // disabled 時にだけ適用されるスタイル
          "& .MuiOutlinedInput-root.Mui-disabled": {
            backgroundColor: "#DDDDDD",
            color: "#777777",
            cursor: "not-allowed",
          },
        }}
      />
    </Box>
  );
};

export default FormTextField;
